import { render, staticRenderFns } from "./semiWelcome.vue?vue&type=template&id=1ad51588&scoped=true"
import script from "./semiWelcome.vue?vue&type=script&lang=js"
export * from "./semiWelcome.vue?vue&type=script&lang=js"
import style0 from "./semiWelcome.vue?vue&type=style&index=0&id=1ad51588&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad51588",
  null
  
)

export default component.exports